module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-form-table', {
    attrs: {
      "form": _vm.form,
      "list": _vm.hours,
      "create": _vm.save,
      "destroy": _vm.destroy,
      "translation": "table.businessHours"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69b8f5d2","hasScoped":false}!./src/app/components/openHours/openHours.html
// module id = 3046
// module chunks = 1